export default __webpack_public_path__ + "static/media/Wide-Assortment.49b2854c.png";